<template>
  <div class="main">
    <webheader></webheader>
    <div class="information"
         v-loading="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.4)">
      <div style="height:100px"></div>

      <el-scrollbar style="height:100%; ">
        <div class="infos flex-left"
             v-infinite-scroll="load"
             infinite-scroll-disabled="disabled"
             style="overflow:auto">
          <div class="first-title">
            神漫资讯
          </div>
          <div class="flex-top"
               style="width:100%;padding-bottom:40px;">
            <div class="divider"></div>
            <div class="flex-top"
                 style="padding-top:20px; ">
              <div class="text-gradient">
                <div class="en-title">
                  Shenman information
                </div>
              </div>
            </div>
            <div class="divider"></div>
          </div>
          <div class="flex-left"
               style=" flex-wrap: wrap; min-height:522px;  overflow-y: auto;width:100%">
            <div class="info-item"
                 v-for="(item,index) in infoList"
                 :key="index">
              <div class="info-img">
                <img :src="item.thumb"
                     class="info-img"
                     alt="">
              </div>
              <div class="info">
                <div class="info-title">{{index+1}} {{item.title}}</div>
                <div class="info-time">{{item.updatetime}}</div>
                <div class="info-desc">{{item.content}}</div>
              </div>
            </div>
            <p v-if="noMore"
               style="width:100%;color:white;text-align:center">没有更多了...</p>
          </div>

        </div>
      </el-scrollbar>
    </div>
    <tabfooter></tabfooter>
  </div>
</template>

<script>
import webheader from '@/components/webheader'
import tabfooter from '@/components/tabfooter'
import { selectArticle } from '@/api/website'
export default {
  components: { tabfooter, webheader },
  computed: {
    noMore () {
      return this.infoList.length >= this.total
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  name: 'realtime',
  data () {
    return {
      currentPage: 1,
      loading: false,
      total: 0,
      defaultList: [],
      infoList: [
      ]
    }
  },
  created () { this.initRealtimeList() },
  methods: {
    initRealtimeList () {
      let data = {
        page: this.currentPage
      }
      selectArticle(data).then(res => {
        if (res.code === 0) {
          if (this.currentPage > 1) {
            this.infoList = [...this.infoList, ...res.data.data]
          } else {
            this.infoList = res.data.data
            this.total = res.data.total
          }

          this.loading = false
        }
      })
    },
    load () {
      this.currentPage++
      let that = this
      that.loading = true
      that.initRealtimeList()
    }

  }
}
</script>

<style scoped>
.information {
  height: calc(100% - 145px);
}
.info-time {
  height: 25px;
  font-size: 12px;
  line-height: 25px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(139, 139, 139, 1);
  opacity: 1;
}
.info-desc {
  width: 311px;
  height: 40px;

  font-size: 10px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(222, 222, 222, 1);
  opacity: 1;
}
.infos {
  padding: 0 48px;
  flex-wrap: wrap;
  height: 670px;
  overflow-y: auto;
}
.info {
  padding: 8px 16px;
}
.info-title {
  height: 16px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 16px;
  padding-top: 12px;
  padding-bottom: 8px;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
}
.info-img {
  width: 340px;
  height: 123px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.info-item {
  margin: 12px;
  width: 340px;
  height: 237px;
  background: rgba(33, 32, 32, 1);
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.3);
  opacity: 1;
  border-radius: 15px;
}
.divider {
  width: calc(50% - 270px);
  margin-top: 30px;
  margin-left: 50px;
  margin-right: 50px;
  border: 1px solid #8b8b8b;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/view/realtime.vue